/**
 * Stable CSS class names for E2E — Customer communication preferences report (CPL embed) page.
 */
export const CCPR = {
    page: 'customer-communication-preferences-report-page',
    frameCard: 'customer-communication-preferences-report-page__frame-card',
    iframe: 'customer-communication-preferences-report-page__iframe',
    fallbackAlert: 'customer-communication-preferences-report-page__fallback-alert',
    openInNewTabButton: 'customer-communication-preferences-report-page-input--button-open-new-tab',
} as const;
